import { ReactComponent as InfoIcon } from "assets/products/shared/icons/info.svg";

import ModalTemplate from "components/modal/modal-template/ModalTemplate";

const InfoPolicyBeneficiaryModal = () => {
    return (
        <ModalTemplate
            trigger={
                <InfoIcon
                    className="w-4 h-4 cursor-pointer"
                    tabIndex={-1}
                    onMouseDown={(e) => e.preventDefault()}
                    onFocus={(e) => e.stopPropagation()}
                />
            }
            modalId="info-policy-beneficiary-modal"
            className="p-0 tablet:max-w-[600px] max-w-[370px]"
        >
            <div className="p-6 font-sans text-base font-medium leading-6 text-black space-y-4 [&_p]:text-black text-left">
                <p>The definition of spouse is determined by your state's law.</p>
                <p>
                    <span className="font-bold">Child includes:</span> Biological, adopted, and stepchildren, as well as legal
                    guardianship of children under 18.
                </p>
                <p>
                    <span className="font-bold">Parent includes:</span> Mother, father, stepmother, stepfather, mother-in-law,
                    father-in-law.
                </p>
                <p>
                    <span className="font-bold">Naming a trust or charity:</span> You are unable to name a trust or charity as
                    your beneficiary at this time. If approved, you can call our Member Services Department at{" "}
                    <a href="tel:8886168977" className="text-sm font-bold leading-5 text-primary underline">
                        (888) 616-8977
                    </a>{" "}
                    to edit your beneficiaries.
                </p>
            </div>
        </ModalTemplate>
    );
};

export default InfoPolicyBeneficiaryModal;
